<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
        <v-icon color="error" size="96">mdi-lock-alert-outline</v-icon>
        <h1 class="section-title">Acceso Denegado</h1>
        <p class="denied-message">
          Tu usuario no cuenta con los permisos necesarios para acceder a la
          sección que intentaste abrir. Si consideras que esto es un error,
          contacta a un administrador.
        </p>
        <v-btn color="secondary" @click="goToPos">Regresar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'denegado',
  methods: {
    goToPos() {
      this.$router.replace('/pos');
    },
  },
};
</script>

<style lang="less" scoped>
.section-title {
  font-weight: 300;
  font-size: 2.5rem;
  margin-top: 16px;
}

.denied-message {
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.6);
  margin: 16px 0 24px;
}
</style>
